import TransitionMap from 'liquid-fire/transition-map';
export default TransitionMap;
